import _ from 'lodash'

export default props => {
  const {
    className = 'text-secondary text-sm',
    style = {}
  } = props

  return (
    <a onClick={props.onClick} className={className} style={style}>
      {props.icon}
      <span>{props.text}</span>
      <style jsx>{`
        span {
          margin-left: 5px;
        }
      `}
      </style>
    </a>
  )
}
